import Swal from "sweetalert2";
import { Field, Form } from 'react-final-form';
import React, { useState, useEffect } from 'react';
import { Button } from '@/shared/components/Button';
import AdminInterface from '@/utils/AdminInterface';
import TimetableIcon from 'mdi-react/TimetableIcon';
import withReactContent from "sweetalert2-react-content";
import { Card, CardBody, CardTitleWrap, CardTitle } from '@/shared/components/Card';
import renderDateTimePickerField from '@/shared/components/form/date-pickers/DateTimePicker';
import { FormButtonToolbar, FormContainer, FormGroup, FormGroupField, FormGroupLabel, FormGroupIcon } from '@/shared/components/form/FormElements';

const required = value => (value ? undefined : 'Required')

const CalibrationsList = (props) => {
    const [calibration, setCalibration] = useState();

    useEffect(() => {
        if (props.selectedCalibration === undefined) return;
        let data = {};
        data.id = props.selectedCalibration.id;
        data.description = props.selectedCalibration.description;
        data.calibration_date = new Date(`${props.selectedCalibration.calibration_date}z`);
        data.s3_uri = props.selectedCalibration.s3_uri;
        setCalibration(data);

    }, [props.selectedCalibration]);

    const submitCalibrationUpdates = (calibration) => {
        AdminInterface.instance.updateCalibration(calibration).then(() => {
            Swal.fire('Updated!', '', 'success')
            props.setListRequiresReload(true);
        }).catch((error) => {
            withReactContent(Swal).fire({
                title: "Error",
                html: [error.response?.data?.detail.map((detail) => detail.msg)],
            });
        })
    }

    return (
        <Card>
            <CardBody>
                <CardTitleWrap>
                    <CardTitle>Edit Calibration</CardTitle>
                </CardTitleWrap>
                <Form onSubmit={submitCalibrationUpdates} initialValues={calibration}>
                    {({ handleSubmit, form }) => (
                        <FormContainer horizontal onSubmit={handleSubmit}>
                            <FormGroup>
                                <FormGroupLabel>Description</FormGroupLabel>
                                <FormGroupField>
                                    <Field name="description" component="input" type="text" placeholder="Description" />
                                </FormGroupField>
                            </FormGroup>
                            <FormGroup>
                                <FormGroupLabel>Start Datetime</FormGroupLabel>
                                <FormGroupField>
                                    <Field name="calibration_date" component={renderDateTimePickerField} placeholder="Calibration Datetime" validate={required} />
                                    <FormGroupIcon><TimetableIcon/></FormGroupIcon>
                                </FormGroupField>
                            </FormGroup>
                            <FormGroup>
                                <FormGroupLabel>S3 URI</FormGroupLabel>
                                <FormGroupField>
                                    <Field name="s3_uri" component="input" type="text" placeholder="s3://" />
                                </FormGroupField>
                            </FormGroup>
                            <FormButtonToolbar>
                                <Button variant="primary" type="submit">Submit</Button>
                                <Button variant="secondary" type="button" onClick={() => props.setSelectedCalibration(null)}>
                                    Cancel
                                </Button>
                            </FormButtonToolbar>
                        </FormContainer>
                    )}
                </Form>
            </CardBody>
        </Card>
    );
};

export default CalibrationsList;